/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AbpPtwExceptionHttpResponseModel,
  CreateDefinitionDto,
  CreateUpdateNumericQuantityDto,
  DefinitionDto,
  GetDefinitionCatalogs200Response,
  HistoryDto,
  NumericQuantityDto,
  ODataPostProcessedResultsOfNumericQuantityDto,
  ProblemDetails,
} from '../models/index';
import {
    AbpPtwExceptionHttpResponseModelFromJSON,
    AbpPtwExceptionHttpResponseModelToJSON,
    CreateDefinitionDtoFromJSON,
    CreateDefinitionDtoToJSON,
    CreateUpdateNumericQuantityDtoFromJSON,
    CreateUpdateNumericQuantityDtoToJSON,
    DefinitionDtoFromJSON,
    DefinitionDtoToJSON,
    GetDefinitionCatalogs200ResponseFromJSON,
    GetDefinitionCatalogs200ResponseToJSON,
    HistoryDtoFromJSON,
    HistoryDtoToJSON,
    NumericQuantityDtoFromJSON,
    NumericQuantityDtoToJSON,
    ODataPostProcessedResultsOfNumericQuantityDtoFromJSON,
    ODataPostProcessedResultsOfNumericQuantityDtoToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/index';

export interface CreateNumericQuantityRequest {
    createUpdateNumericQuantityDto?: CreateUpdateNumericQuantityDto;
}

export interface DeleteNumericQuantityRequest {
    id: string;
}

export interface GetDefinitionCatalogRequest {
    id: string;
}

export interface GetDefinitionCatalogsRequest {
    requestBody?: Array<string>;
}

export interface GetNumericQuantityRequest {
    id: string;
}

export interface GetNumericQuantityListRequest {
    $filter?: string;
    $search?: string;
    $top?: number;
    $skip?: number;
    $orderby?: string;
}

export interface GetQuantityHistoryRequest {
    id: string;
}

export interface UpdateNumericQuantityRequest {
    id: string;
    createUpdateNumericQuantityDto?: CreateUpdateNumericQuantityDto;
}

export interface ValidateDefinitionRequest {
    createDefinitionDto?: CreateDefinitionDto;
}

export interface ValidateDefinitionWithValueSetsRequest {
    createDefinitionDto?: CreateDefinitionDto;
}

export interface ValidateNumericQuantityRequest {
    createUpdateNumericQuantityDto?: CreateUpdateNumericQuantityDto;
}

/**
 * 
 */
export class NumericQuantitiesApi extends runtime.BaseAPI {

    /**
     * Adds a new entity
     */
    async createNumericQuantityRaw(requestParameters: CreateNumericQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NumericQuantityDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/numeric-quantities`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateNumericQuantityDtoToJSON(requestParameters.createUpdateNumericQuantityDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => NumericQuantityDtoFromJSON(jsonValue));
    }

    /**
     * Adds a new entity
     */
    async createNumericQuantity(requestParameters: CreateNumericQuantityRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.createNumericQuantityRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<NumericQuantityDto>(response, errorHandlers);
    }

    /**
     * Deletes the entity with the given id.
     */
    async deleteNumericQuantityRaw(requestParameters: DeleteNumericQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteNumericQuantity.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/numeric-quantities/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes the entity with the given id.
     */
    async deleteNumericQuantity(requestParameters: DeleteNumericQuantityRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.deleteNumericQuantityRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     */
    async getDefinitionCatalogRaw(requestParameters: GetDefinitionCatalogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DefinitionDto>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getDefinitionCatalog.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/numeric-quantities/{id}/definition-catalog`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DefinitionDtoFromJSON));
    }

    /**
     */
    async getDefinitionCatalog(requestParameters: GetDefinitionCatalogRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getDefinitionCatalogRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<Array<DefinitionDto>>(response, errorHandlers);
    }

    /**
     */
    async getDefinitionCatalogsRaw(requestParameters: GetDefinitionCatalogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDefinitionCatalogs200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/numeric-quantities/definition-catalog`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            // FIXED: This is the original code. Had to add "?" for optional arrays
            // body: requestParameters.requestBody,
            body: requestParameters.requestBody,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => GetDefinitionCatalogs200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getDefinitionCatalogs(requestParameters: GetDefinitionCatalogsRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getDefinitionCatalogsRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<GetDefinitionCatalogs200Response>(response, errorHandlers);
    }

    /**
     * Returns one entity for detail view.
     */
    async getNumericQuantityRaw(requestParameters: GetNumericQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NumericQuantityDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getNumericQuantity.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/numeric-quantities/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => NumericQuantityDtoFromJSON(jsonValue));
    }

    /**
     * Returns one entity for detail view.
     */
    async getNumericQuantity(requestParameters: GetNumericQuantityRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getNumericQuantityRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<NumericQuantityDto>(response, errorHandlers);
    }

    /**
     */
    async getNumericQuantityCatalogRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<NumericQuantityDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/numeric-quantities/catalog`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(NumericQuantityDtoFromJSON));
    }

    /**
     */
    async getNumericQuantityCatalog(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getNumericQuantityCatalogRaw(initOverrides);
        return this.configuration.handleFunction<Array<NumericQuantityDto>>(response, errorHandlers);
    }

    /**
     * Returns a list of entities for grid view.
     */
    async getNumericQuantityListRaw(requestParameters: GetNumericQuantityListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ODataPostProcessedResultsOfNumericQuantityDto>> {
        const queryParameters: any = {};

        if (requestParameters.$filter !== undefined) {
            queryParameters['$filter'] = requestParameters.$filter;
        }

        if (requestParameters.$search !== undefined) {
            queryParameters['$search'] = requestParameters.$search;
        }

        if (requestParameters.$top !== undefined) {
            queryParameters['$top'] = requestParameters.$top;
        }

        if (requestParameters.$skip !== undefined) {
            queryParameters['$skip'] = requestParameters.$skip;
        }

        if (requestParameters.$orderby !== undefined) {
            queryParameters['$orderby'] = requestParameters.$orderby;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/numeric-quantities`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => ODataPostProcessedResultsOfNumericQuantityDtoFromJSON(jsonValue));
    }

    /**
     * Returns a list of entities for grid view.
     */
    async getNumericQuantityList(requestParameters: GetNumericQuantityListRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getNumericQuantityListRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<ODataPostProcessedResultsOfNumericQuantityDto>(response, errorHandlers);
    }

    /**
     */
    async getQuantityHistoryRaw(requestParameters: GetQuantityHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<HistoryDto>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getQuantityHistory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/numeric-quantities/{id}/history`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HistoryDtoFromJSON));
    }

    /**
     */
    async getQuantityHistory(requestParameters: GetQuantityHistoryRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getQuantityHistoryRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<Array<HistoryDto>>(response, errorHandlers);
    }

    /**
     * Updates an entity, if existing
     */
    async updateNumericQuantityRaw(requestParameters: UpdateNumericQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NumericQuantityDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateNumericQuantity.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/numeric-quantities/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateNumericQuantityDtoToJSON(requestParameters.createUpdateNumericQuantityDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => NumericQuantityDtoFromJSON(jsonValue));
    }

    /**
     * Updates an entity, if existing
     */
    async updateNumericQuantity(requestParameters: UpdateNumericQuantityRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.updateNumericQuantityRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<NumericQuantityDto>(response, errorHandlers);
    }

    /**
     */
    async validateDefinitionRaw(requestParameters: ValidateDefinitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/numeric-quantities/definition-validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDefinitionDtoToJSON(requestParameters.createDefinitionDto),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async validateDefinition(requestParameters: ValidateDefinitionRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.validateDefinitionRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     */
    async validateDefinitionWithValueSetsRaw(requestParameters: ValidateDefinitionWithValueSetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/numeric-quantities/definition-value-sets-validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDefinitionDtoToJSON(requestParameters.createDefinitionDto),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async validateDefinitionWithValueSets(requestParameters: ValidateDefinitionWithValueSetsRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.validateDefinitionWithValueSetsRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     * Validates an entity without adding or updating it.
     */
    async validateNumericQuantityRaw(requestParameters: ValidateNumericQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/numeric-quantities/validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateNumericQuantityDtoToJSON(requestParameters.createUpdateNumericQuantityDto),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validates an entity without adding or updating it.
     */
    async validateNumericQuantity(requestParameters: ValidateNumericQuantityRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.validateNumericQuantityRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

}
